import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-header-title" }
const _hoisted_4 = { class: "modal-header-title-topic" }
const _hoisted_5 = { class: "text-xl" }
const _hoisted_6 = { class: "modal-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"modal-header-title-logo\"><svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.69466 11.9233L13.548 5.07C14.0687 4.54933 14.0687 3.70534 13.548 3.18467L12.8 2.436C12.2793 1.91534 11.4353 1.91534 10.9147 2.436L4.06066 9.29C3.96333 9.38734 3.882 9.49934 3.81866 9.62134L2.06533 13.0187C1.768 13.5953 2.386 14.214 2.96266 13.9173L6.362 12.1667C6.48533 12.1027 6.59733 12.0213 6.69466 11.9233Z\" stroke=\"#323232\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M3.93994 9.46001L6.52661 12.0467\" stroke=\"#323232\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M12 14H2.69336\" stroke=\"#323232\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></div>", 1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.modalTitle), 1),
          _cache[1] || (_cache[1] = _createElementVNode("p", null, "Description", -1))
        ])
      ]),
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
        class: "modal-header-exit"
      }, "X")
    ]),
    _createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}